<div class="relative">
  <tui-loader [overlay]="true" [showLoader]="isLoading">
    <div class="container">
      <!-- Header -->
      <div class="flex gap-3 border-b border-b-[#bb0021] pb-2">
        <button class="p-2 cursor-pointer" (click)="cancel()">
          <tui-svg
            src="tuiIconArrowLeftCircleLarge"
            style="color: black"
            class="hover:scale-110 transition-all duration-100"
          ></tui-svg>
        </button>
        <p class="flex items-center text-black text-[1.5rem] font-bold">
          {{ status === "edit" ? "Edit Member" : "Add New Member" }}
        </p>
      </div>

      <!-- Form -->
      <div
        class="flex items-center justify-center xl:justify-normal mt-5 2xl:my-10 lg:ml-10"
      >
        <div class="w-full sm:w-[400px]">
          <form [formGroup]="memberForm">
            <!-- Profile Picture -->
            <div class="flex flex-col items-center mt-5 mb-8">
              <div class="relative">
                <div
                  class="w-32 h-32 rounded-full border-2 border-gray-300 overflow-hidden bg-gray-100 flex items-center justify-center"
                >
                  <img
                    *ngIf="profilePictureObj"
                    [src]="profilePictureObj.url"
                    alt="Profile"
                    class="w-full h-full object-cover rounded-full"
                  />
                  <tui-svg
                    *ngIf="!profilePictureObj"
                    src="tuiIconUser"
                    class="w-full h-full text-gray-400"
                  ></tui-svg>
                </div>

                <div class="flex gap-2 justify-center mt-3">
                  <button
                    type="button"
                    tuiButton
                    class="w-10 h-10"
                    (click)="fileInput.click()"
                  >
                    <tui-svg src="tuiIconUpload" />
                  </button>
                  <button
                    type="button"
                    *ngIf="profilePictureObj"
                    tuiButton
                    appearance="secondary"
                    class="w-10 h-10"
                    (click)="removeProfilePicture()"
                  >
                    <tui-svg src="tuiIconTrash" />
                  </button>
                </div>
              </div>

              <input
                #fileInput
                type="file"
                accept="image/*"
                class="hidden"
                (change)="onFileSelected($event)"
              />
              <p class="text-gray-600 text-sm mt-3 text-center">
                Click the upload button to select an image
              </p>
              <p class="text-gray-400 text-xs text-center">
                Recommended: Square image, at least 200x200 pixels
              </p>
            </div>

            <!-- Inputs -->
            <div>
              <!-- Membership ID -->
              <div class="mb-4">
                <label class="text-black">Enter Club ID</label>
                <tui-input
                  tuiTextfieldSize="l"
                  [tuiTextfieldCleaner]="true"
                  [tuiTextfieldLabelOutside]="true"
                  class="tui-space_top-1"
                  formControlName="membershipId"
                >
                  <input
                    autocomplete="mid"
                    tuiTextfield
                    type="text"
                    placeholder="Club ID"
                  />
                  Club ID
                </tui-input>
                <tui-error
                  formControlName="membershipId"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
              </div>

              <!-- Full Name -->
              <div class="mb-4">
                <label class="text-black">Enter Full Name</label>
                <tui-input
                  tuiTextfieldSize="l"
                  [tuiTextfieldCleaner]="true"
                  [tuiTextfieldLabelOutside]="true"
                  class="tui-space_top-1"
                  formControlName="fullname"
                >
                  <input
                    autocomplete="fullname"
                    tuiTextfield
                    type="text"
                    placeholder="Full Name"
                  />
                  Full Name
                </tui-input>
                <tui-error
                  formControlName="fullname"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
              </div>

              <!-- DOB -->
              <div class="mb-4">
                <label class="text-black">Date Of Birth</label>
                <tui-input-date
                  tuiTextfieldSize="l"
                  [tuiTextfieldCleaner]="true"
                  [tuiTextfieldLabelOutside]="true"
                  class="tui-space_top-1"
                  formControlName="dob"
                >
                  <input
                    autocomplete="dob"
                    tuiTextfield
                    type="text"
                    placeholder="Choose a date"
                  />
                  Choose a date
                </tui-input-date>
                <tui-error
                  formControlName="dob"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
              </div>

              <!-- Mobile Number -->
              <div class="mb-4">
                <label class="text-black">Enter Mobile Number</label>
                <tui-input
                  tuiTextfieldSize="l"
                  [tuiTextfieldCleaner]="true"
                  [tuiTextfieldLabelOutside]="true"
                  class="tui-space_top-1"
                  formControlName="mobileNo"
                >
                  <input
                    autocomplete="phone"
                    tuiTextfield
                    type="tel"
                    placeholder="Mobile Number"
                  />
                  Mobile Number
                </tui-input>
                <tui-error
                  formControlName="mobileNo"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
              </div>

              <!-- Programs Multi-select -->
              <div class="mb-4">
                <label class="text-black">Select Program</label>
                <tui-multi-select
                  placeholder="Choose Programs"
                  [editable]="false"
                  formControlName="programs"
                  [tagValidator]="tagValidator"
                  [tuiTextfieldLabelOutside]="true"
                  [(search)]="search"
                >
                  Choose Programs
                  <tui-data-list-wrapper
                    *tuiDataList
                    [items]="filter(search)"
                  ></tui-data-list-wrapper>
                </tui-multi-select>
              </div>

              <!-- Package -->
              <div class="mb-4">
                <label class="text-black">Select Package</label>
                <tui-select
                  formControlName="package"
                  [valueContent]="packageContent"
                  [tuiTextfieldLabelOutside]="true"
                  placeholder="Choose a package"
                >
                  Choose a package
                  <tui-data-list-wrapper
                    *tuiDataList
                    [itemContent]="packageContent"
                    [items]="packageOptions"
                  />
                </tui-select>
                <tui-error
                  formControlName="package"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
                <ng-template #packageContent let-item>
                  <div>{{ item.name }}</div>
                </ng-template>
              </div>

              <!-- Session -->
              <div class="mb-4">
                <label class="text-black">Select Session Type</label>
                <tui-select
                  formControlName="session"
                  [tuiTextfieldLabelOutside]="true"
                  placeholder="Choose a session type"
                >
                  Choose a session type
                  <tui-data-list-wrapper
                    *tuiDataList
                    [items]="sessions"
                  ></tui-data-list-wrapper>
                </tui-select>
                <tui-error
                  formControlName="session"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
              </div>

              <!-- Email -->
              <div class="mb-4">
                <label class="text-black">Enter Email Address</label>
                <tui-input
                  tuiTextfieldSize="l"
                  [tuiTextfieldCleaner]="true"
                  [tuiTextfieldLabelOutside]="true"
                  class="tui-space_top-1"
                  formControlName="email"
                >
                  <input
                    autocomplete="email"
                    tuiTextfield
                    type="email"
                    placeholder="Email Address"
                  />
                  Email Address
                </tui-input>
                <tui-error
                  formControlName="email"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
              </div>

              <!-- Address -->
              <div class="mb-4">
                <label class="text-black">Enter Address</label>
                <tui-textarea
                  tuiTextfieldSize="l"
                  [tuiTextfieldCleaner]="true"
                  [tuiTextfieldLabelOutside]="true"
                  class="tui-space_top-1"
                  formControlName="address"
                  placeholder="Address"
                >
                  Address
                </tui-textarea>
                <tui-error
                  formControlName="address"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
              </div>

              <!-- Registration Date -->
              <div class="mb-4">
                <label class="text-black">Member Since (Date)</label>
                <tui-input-date
                  tuiTextfieldSize="l"
                  [tuiTextfieldCleaner]="true"
                  [tuiTextfieldLabelOutside]="true"
                  class="tui-space_top-1"
                  formControlName="registrationDate"
                >
                  <input
                    autocomplete="msd"
                    tuiTextfield
                    type="text"
                    placeholder="Choose a date"
                  />
                  Choose a date
                </tui-input-date>
                <tui-error
                  formControlName="registrationDate"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
              </div>

              <!-- Gender -->
              <div class="mb-4">
                <label class="text-black">Gender</label>
                <div class="flex gap-5 mt-1">
                  <tui-radio-labeled item="MALE" formControlName="gender"
                    ><span class="text-black">Male</span></tui-radio-labeled
                  >
                  <tui-radio-labeled item="FEMALE" formControlName="gender"
                    ><span class="text-black">Female</span></tui-radio-labeled
                  >
                  <tui-radio-labeled item="OTHER" formControlName="gender"
                    ><span class="text-black">Other</span></tui-radio-labeled
                  >
                </div>
                <tui-error
                  formControlName="gender"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
              </div>

              <!-- Emergency Contact -->
              <p class="text-black font-bold pt-4">Emergency Contact details</p>
              <div
                class="flex flex-col sm:flex-row gap-3 w-full"
                formGroupName="emergencyContact"
              >
                <div class="w-full">
                  <label class="text-black">Enter Name</label>
                  <tui-input
                    tuiTextfieldSize="l"
                    [tuiTextfieldCleaner]="true"
                    [tuiTextfieldLabelOutside]="true"
                    formControlName="name"
                  >
                    <input
                      autocomplete="name"
                      tuiTextfield
                      type="text"
                      placeholder="Name"
                    />
                    Name
                  </tui-input>
                  <tui-error
                    formControlName="name"
                    [error]="[] | tuiFieldError | async"
                  ></tui-error>
                </div>
                <div class="w-full">
                  <label class="text-black">Enter Mobile Number</label>
                  <tui-input
                    tuiTextfieldSize="l"
                    [tuiTextfieldCleaner]="true"
                    [tuiTextfieldLabelOutside]="true"
                    formControlName="mobileNo"
                  >
                    <input
                      autocomplete="mobile"
                      tuiTextfield
                      type="tel"
                      placeholder="Mobile Number"
                    />
                    Mobile Number
                  </tui-input>
                  <tui-error
                    formControlName="mobileNo"
                    [error]="[] | tuiFieldError | async"
                  ></tui-error>
                </div>
              </div>

              <!-- Action Buttons -->
              <div class="flex gap-3 mt-5">
                <div class="w-full h-full">
                  <button
                    (click)="cancel()"
                    tuiButton
                    appearance="secondary"
                    type="button"
                    class="w-full h-full text-[#bb0021] hover:bg-[#faf0f2] hover:text-[#bb0021]"
                  >
                    Cancel
                  </button>
                </div>
                <div class="w-full">
                  <button
                    tuiButton
                    type="button"
                    class="w-full"
                    (click)="status === 'edit' ? onUpdate() : submit()"
                    [showLoader]="isLoading"
                  >
                    {{ status === "edit" ? "Update Member" : "Add Member" }}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </tui-loader>
</div>
